<template>
  <div
    role="group"
    aria-label="Accounts Table Columns Selection"
    class="btn-group tabs-table"
  >
    <button
      type="button"
      class="btn btn-secondary"
      :class="{active: selected === 'overview'}"
      @click="onSelect('overview')"
    >
      Primary Details
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      :class="{ active: selected === 'appointments' }"
      @click="onSelect('appointments')"
    >
      30 Day Session Stats
    </button>
  </div>
</template>

<script>
export default {
  name: 'CounselorTableTabs',

  props: {
    selected: {
      type: String,
      required: true
    },
    onSelect: {
      type: Function,
      required: true
    }
  },
};
</script>
